
// import { toast } from "react-toastify";
// import ServerAddress from "../utils/ServerAddress";

// const apiRequest = async (url, method, token, data = null) => {
//   const headers = { "Content-Type": "application/json" };
//   if (token) headers.Authorization = `Bearer ${token}`;
// // console.log("token==>",token)
//   const config = { method, headers };
//   if (data) config.body = JSON.stringify(data);

//   try {
//     const response = await fetch(`${ServerAddress}${url}`, config);

//     if (response.status === 204) return {};

//     const result = await response.json().catch(() => ({}));

//     if (response.ok) {
//       return result;
//     }

//     const message =
//       result?.message || `Request failed with status ${response.status}`;

//     const err = new Error(message);
//     err.status = response.status;
//     err.silent = true;
//     throw err;

//   } catch (error) {
//     console.error("API Error:", error);

//     // if (!error.silent) {
//     //   toast.error(error.message || "Something went wrong");
//     // }

//     throw error;
//   }
// };

// export default apiRequest;


import ServerAddress from "../utils/ServerAddress";

const apiRequest = async (url, method, token, data = null) => {
  const headers = { "Content-Type": "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;

  const config = { method, headers };
  if (data) config.body = JSON.stringify(data);

  try {
    const response = await fetch(`${ServerAddress}${url}`, config);

    if (response.status === 204) return {};

    const result = await response.json().catch(() => ({}));

    if (response.ok) {
      return result;
    }

    // 3. Handle specific Error Status Codes
    const errorMessage = result?.message || `Error: ${response.status}`;

    if (response.status === 401) {
      // ONLY logout on 401 (Expired/Invalid Token)
      handleSessionExpired();
      return;
    } 
    
    if (response.status === 403) {
      // Forbidden: Keep user logged in, but show warning
      console.log("Access Denied: You don't have permission.");
    } else if (response.status >= 400 && response.status < 500) {
      // Bad Request (Wrong payload): Just show the error, don't logout
     console.log(errorMessage);
    } else {
      // Server Errors (500+)
     console.log("Server error Please try again later.");
    }

    // Throw the error so the component's catch block can still work
    const err = new Error(errorMessage);
    err.status = response.status;
    throw err;

  }   catch (error) {
    let errorMessage = error instanceof Error ? error.message : String(error); 
    errorMessage = errorMessage.replace(/^error:\s*/i, "").replace(/^error:\s*/i, "");
    console.error(`API Error: ${errorMessage.trim()}`);
    throw error;
  }
};

//  Helper to handle cleanup without cluttering the main function

const handleSessionExpired = () => {
  localStorage.clear(); 
  console.log("Session expired. Redirecting to login...");
  
  setTimeout(() => {
    window.location.href = "/";
  }, 500);
};

export default apiRequest;
